// extracted by mini-css-extract-plugin
export default {"ErrorBanner":"ErrorBanner_ErrorBanner__tgT4j","icon":"ErrorBanner_icon__l2kP+"};